// Copyright (c) Move Closer 2022.

import { ProfileTabItem } from '../../profile/services/profile-tabs'

import { RouteNames } from '../../products/routes'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const productTabs: ProfileTabItem[] = [
  // FIXME when favourite product is ready
  // {
  //   label: 'favourite',
  //   routeName: `products.${RouteNames.Favourite}`,
  //   priority: 70
  // }
]
